import { Methods } from '@api/entry/check'
import { Request } from '../../request'
export default async (query:Methods["get"]["query"]) => Request( client => client.entry.check.$get({query}) )
